import {InitThumbnails, showThumbnails} from "./thumbnails";

export default class CardsOccupation {
	static initAll() {
		const cardWrappers = document.querySelectorAll('.cards-occupation');

		if (cardWrappers.length === 0) {
			return;
		}

		cardWrappers.forEach((cardWrapper) => this.init(cardWrapper));
	}

	static init(cardWrapper) {
		return new CardsOccupation(cardWrapper);
	}

	constructor(cardWrapper) {
		const cards = cardWrapper.querySelectorAll('.card-georg');

		if (cards.length === 0) {
			return;
		}

		this.cardIndex = parseInt(cardWrapper.dataset.initialOffset, 10) || 9;

		InitThumbnails(cards, this.cardIndex);
		this._initLoadMore(cardWrapper, cards);
	}

	_initLoadMore(cardWrapper, cards) {
		const buttonLoadMore = cardWrapper.querySelector('.button-load-more');

		if (buttonLoadMore === null)
			return;

		if (this.cardIndex >= cards.length)
			buttonLoadMore.style.display = 'none';
		else
			buttonLoadMore.style.display = 'block';

		buttonLoadMore.addEventListener('click', () => {
			showThumbnails(cards, this.cardIndex);

			buttonLoadMore.style.display = 'none';
		});
	}
}
